import React from "react";
import { Send } from "lucide-react";
import { ApplyModal } from "./ApplyModal";

function ContactModal({ accentColor, title, lang, enrollBtn, onCloseParent }) {
  const [show, setShow] = React.useState(false);
  const label = lang === "az" ? "Müraciət et" : lang === "ru" ? "Подать заявку" : "Apply Now";
  return (
    <>
      <button
        onClick={() => setShow(true)}
        className="flex items-center justify-center gap-2 w-full text-white py-3.5 rounded-xl font-bold text-base hover:opacity-90 transition-opacity shadow-lg"
        style={{ background: accentColor }}
      >
        <Send className="w-5 h-5" />{label}
      </button>
      <ApplyModal show={show} onClose={() => { setShow(false); onCloseParent(); }} lang={lang} accentColor={accentColor} courseTitle={title} />
    </>
  );
}

export { ContactModal };
